import { HttpBackend, HttpClient } from "@angular/common/http";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { environment } from "../../../environments/environment";
import { AuthModeService } from "../_services/auth-mode.service";

// Uses HttpBackend directly to bypass the auth interceptor — the interceptor
// depends on AuthenticationService, which in Stage 2 will depend on
// AuthModeService, creating a DI cycle if this request went through the
// interceptor pipeline.
export async function probeAuthMode(): Promise<void> {
  const authModeService = inject(AuthModeService);
  const httpBackend = inject(HttpBackend);
  const http = new HttpClient(httpBackend);

  try {
    const response = await firstValueFrom(
      http.get<{ mode?: unknown }>(`${environment.developmentUrl}auth-config`)
    );
    authModeService.setMode(response?.mode);
  } catch (err) {
    console.warn("auth-config probe failed, defaulting to external mode", err);
  }
}
